import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import comm_data from '../../../comm_data';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../stores/reducer_add';
import DropdownAdmin from './DropdownAdmin';
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray';
import { ADD_USERS_ARRAY } from '../../../stores/reducer_usersArray';

const ResetUserAdmin = (props) => {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const store_res_array = useSelector(state => state.store_residents.orign_residents_array)

    const user = props.user
    const [residentAssign, setResidentAssign] = useState([]);
    const [inputData, setInputData] = useState({
        email: props.user.email,
        last_name: props.user.last_name,
        first_name: props.user.first_name,
    });
    const [pwdData, setPwdData] = useState({
        encrypted_password: '',
        checkPwd: '',
    });
    const [pwdInconsistent, setPwdInconsistent] = useState(false);
    const [residentRow, setResidentRow] = useState([]);
    const [dropdown, setDropdown] = useState(false);
    function toggleDropdown() { setDropdown(!dropdown) }
    const roleSelections = ["superdoctor", "doctor", "admin"]
    const institutionSelections = useSelector(state => state.store_beds.institutions);
    const [returnRole, setReturnRole] = useState(user.role);
    const [returnInstitution, setReturnInstitution] = useState(user.institution);
    const [accPwdSwitch, setAccPwdSwitch] = useState(false);
    const [showPWD, setShowPWD] = useState(false);
    useEffect(() => {
        if (store_res_array.length === 0) {
            ApiGo.getResidents().then(res => {
                setResidentRow(res)
                dispatch(ADD_RESIDENTS_ARRAY(res))
            }).catch()
        }
        else { setResidentRow(store_res_array) }
    }, [store_res_array]);
    useEffect(() => { if (user.resident_assign !== null) setResidentAssign(user.resident_assign.split(",").map(Number)) }, [])
    const orign_resident_assign = user.resident_assign !== null ? user.resident_assign : ""
    const [selectionEff, setSelectionEff] = useState(false);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        let _arr = []
        residentRow.forEach((res, index) => {
            _arr.push(false)
            residentAssign.forEach(r_id => {
                if (parseInt(r_id) === res.id) _arr[index] = true
            })
        });
        setSelected(_arr)
    }, [residentAssign, residentRow])

    function handleInput(value, index) {
        let _addText = {}
        switch (index) {
            case 0: _addText = { email: `${value}@example.com` }; break;
            case 3: _addText = { last_name: value }; break;
            case 4: _addText = { first_name: value }; break;
            default:
                break;
        }
        setInputData({ ...inputData, ..._addText })
    }
    function handlePWDInput(value, index) {
        let _addText = {}
        switch (index) {
            case 0:
                setPwdInconsistent(false)
                if (pwdData.checkPwd !== undefined) {
                    let _index = value.length - 1
                    if (value[_index] !== pwdData.checkPwd[_index]) { setPwdInconsistent(true) }
                }
                _addText = { encrypted_password: value }
                break;
            case 1:
                setPwdInconsistent(false)
                if (pwdData.encrypted_password !== undefined) {
                    let _index = value.length - 1
                    if (value[_index] !== pwdData.encrypted_password[_index]) { setPwdInconsistent(true) }
                }
                else { setPwdInconsistent(true) }
                _addText = { checkPwd: value }
                break;
            default:
                break;
        }
        setPwdData({ ...pwdData, ..._addText })
    }

    function handleSubmission() {
        if (!accPwdSwitch) {
            let _add = {
                "role": returnRole,
                "resident_assign": residentAssign.join(","),
                "institution": returnInstitution
            }
            let _data = { ...inputData, ..._add }
            if (_data.checkPwd !== _data.encrypted_password) { setPwdInconsistent(true) }
            else {
                ApiGo.update_user(_data)
                    .then((res) => {
                        dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "update_user" }))
                        let _delete = { ..._data, resident_assign: orign_resident_assign }
                        ApiGo.deleteDelete_Residents_Assign(_delete)
                            .then(() => {
                                ApiGo.putCreate_Residents_Assign(_data)
                                    .then(() => {
                                        ApiGo.getUsers()
                                            .then(res => {
                                                dispatch(ADD_USERS_ARRAY(res.users))
                                                props.hide()
                                            })
                                            .catch(err => {
                                                props.hide()
                                            })
                                    })
                                    .catch(err => { console.log(err); })
                            })
                            .catch(err => { console.log(err) })
                    })
                    .catch(err => {
                        dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "update_user" }))
                        return err.response
                    })
                    .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
            }
        }
        else {
            let _data = { ...pwdData, ...{ email: inputData.email } }
            if (_data.checkPwd !== _data.encrypted_password) { setPwdInconsistent(true) }
            else if (_data.checkPwd === "") {
                dispatch(ADD_RESPONSE({ status: 666, statusText: '', type: "update_user_pwd" }))
                props.hide()
            }
            else {
                ApiGo.update_user_password(_data)
                    .then((res) => {
                        dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "update_user_pwd" }))
                        // props.toggleRefresh()
                    })
                    .catch(err => {
                        dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "update_user_pwd" }))
                        return err.response
                    })
                    .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
                props.hide()
            }
        }
    }
    let _accInputDiv = ["GLOBAL.ACCOUNT", "ADMIN.CONNECTION_HIS_PAGE.ROLE", "GLOBAL.INSTITUTION", "GLOBAL.LAST_NAME", "GLOBAL.FIRST_NAME"].map((res, index) => <div key={index} className='fx-d-r w-100 h-10 fx-ccc'>
        <div className='w-20 btn_type _title fx-ccc '>{t(res)}</div>
        <div className='w-75 clickInput'>


            {/* {(index===1)?
                <div className='w-75'>
                    <DropdownAdmin
                        index={"0"}
                        data={{id:returnRole, keys:roleSelections}}
                        toggleDropdown={toggleDropdown}
                        closeToggle={dropdown}
                        returnData = {setReturnRole}/>
                </div>
                :(index===0)?<div className='w-100 acc gray' >{inputData.email}</div>
                :<>
                    <input className='w-100'
                    value={(index===2)?inputData.last_name:(index===3)?inputData.first_name:""}
                    maxLength={(index===5 || index===4)? "20":"10"}
                    type={(index===4 || index===5)? "password":"text"}
                    onChange={e=>{handleInput(e.target.value, index)}}
                    autoComplete='new-password'/>
                    <div className='h-0 w-100 _line'></div>
                </>
            } */}

            {(index === 0) && <div className='w-100 acc gray' >{inputData.email}</div>}
            {(index === 1) &&
                <div className='w-75'>
                    <DropdownAdmin
                        index={"0"}
                        data={{ id: returnRole, keys: roleSelections }}
                        // toggleDropdown={toggleDropdown}
                        // closeToggle={dropdown}
                        returnData={setReturnRole} />
                </div>}
            {(index === 2) &&
                <div className='w-75'>
                    <DropdownAdmin
                        index={"0"}
                        data={{ id: returnInstitution, keys: institutionSelections }}
                        // toggleDropdown={toggleDropdown}
                        // closeToggle={dropdown}
                        returnData={setReturnInstitution} />
                </div>}

            {index > 2 && <> <input className='w-100'
                value={(index === 3) ? inputData.last_name : (index === 4) ? inputData.first_name : ""}
                maxLength={(index === 5 || index === 6) ? "20" : "10"}
                type={(index === 5 || index === 6) ? "password" : "text"}
                onChange={e => { handleInput(e.target.value, index) }}
                autoComplete='new-password' />
                <div className='h-0 w-100 _line'></div>
            </>}

        </div>
    </div>)

    let _pwdInputDiv = ["GLOBAL.PASSWORD", "GLOBAL.COMFIRM_PASSWORD"].map((res, index) => <div key={index} className='fx-d-r w-100 h-10 fx-ccc'>
        <div className='w-20 btn_type _title fx-ccc '>{t(res)}</div>
        <div className='w-75 clickInput'>
            <div className='eyeIcon fx-d-r fx-fec'>
                <div className={`eyeClick ${showPWD ? "wideOpen" : "close"}`} onClick={() => { setShowPWD(!showPWD) }}></div>
            </div>
            <input className={`w-100 ${showPWD ? "eye" : "eyeClose"}`}
                maxLength="20"
                type={(showPWD) ? "text" : "password"}
                onChange={e => { handlePWDInput(e.target.value, index) }}
                autoComplete='new-password' />
            <div className='h-0 w-100 _line'></div>
            {pwdData.checkPwd !== '' ? index === 1 && pwdInconsistent ? <div className='pos-a'>密碼不一致</div> : null : null}
        </div>
    </div>)

    function click_trans_color(_index, _id) {
        let _arr = selected
        let _res_ass_arr = residentAssign
        _arr[_index] = !_arr[_index]
        if (_id === 0) { return }
        if (_arr[_index]) { _res_ass_arr.push(_id) }
        else {
            let _i = _res_ass_arr.indexOf(_id)
            if (_i > -1) { _res_ass_arr.splice(_i, 1) }
        }
        setResidentAssign(_res_ass_arr)
        setSelected(_arr)
    }
    return (
        <>
            <div className='h-80 w-100 fx-d-r'>
                {/* <div className='w-30 fx-d-c h-100 font-l '>
                <div className='w-100 h-10 fx-ccc'>
                    <div className='w-100 btn_type _title fx-ccc'>{t("DASHBOARD.UNASSIGNED_RESIDENT")}</div></div>
                <div className='w-100 h-88 mac_input beige_border ovy-a'>{residentRow.map((res, index)=>
                    <div key={res.first_name+index} className={`font-ml res_layout ${(selected[index])? "add":"none"}`}
                        onMouseLeave={()=>{ setSelectionEff(true)}}
                        onMouseDown={()=>{ setSelectionEff(false)}}
                        onClick={()=>{click_trans_color(index, res.id)}}>
                        {selectionEff? <>
                            <div className='corner_frame _bl'></div>
                            <div className='corner_frame _br'></div>
                            <div className='corner_frame _tl'></div>
                            <div className='corner_frame _tr'></div>
                        </>:null}
                        {res.first_name}
                        {res.last_name}
                    </div>)}
                </div>
            </div> */}
                <div className='w-100 h-100 font-l fx-d-c pad-15 l addSwitch add inputBox beige'>
                    <div className='fx-d-r w-100 h-10 fx-ccc SwitchTag beige'>
                        <div className={`fx-ccc outer_active beige l ${accPwdSwitch ? 'dismiss' : ''}`}
                            onClick={() => { setAccPwdSwitch(false) }}
                        >
                            <div className={`fx-ccc l ${accPwdSwitch ? '' : 'inner_active'}`}>
                                {t("ADMIN.CHANGE_ACCOUNT")}</div>
                        </div>
                        <div className={`fx-ccc outer_active beige r add ${accPwdSwitch ? '' : 'dismiss beige'}`}
                            onClick={() => { setAccPwdSwitch(true) }}
                        >
                            <div className={`fx-ccc r ${accPwdSwitch ? 'inner_active' : ''}`}>
                                {t("ADMIN.CHANGE_PASSWORD")}</div>
                        </div>
                    </div>
                    <div className='outer beige fx-d-c w-100 h-88 fx-cspar'>
                        {accPwdSwitch ? _pwdInputDiv : _accInputDiv}
                    </div>
                </div>
            </div>
            <div className="wrap-personal-btn w-100 h-10 fx-fec">
                <div className="h-100 l-s-container fx-d-r font-m">
                    <div className="fx-ccc w-50 btn_type" onClick={handleSubmission}>{t('GLOBAL.CONFIRM')}</div>
                    <div className="fx-ccc w-50 btn_type" onClick={props.hide}>{t('GLOBAL.CANCEL')}</div>
                </div>
            </div>
        </>
    );

}
export default ResetUserAdmin;